import { FormElementField } from '../FormElements';
import { useBusinessDetailsField } from './hooks';

export const BusinessDetailField = ({
  businessFieldProps = {},
  fieldName,
  inputRef,
  trackingEventType = 'trials',
  trackingEventNamespace = 'signup',
  ...inputProps
}) => {
  const { errorMessage, fieldValue, handleOnBlur, handleOnChange } =
    useBusinessDetailsField({
      ...businessFieldProps,
      fieldName,
      trackingEventType,
      trackingEventNamespace,
    });

  return (
    <FormElementField
      error={errorMessage}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      value={fieldValue}
      {...inputProps}
    />
  );
};
